export default __webpack_public_path__ + "static/media/negative-download.a1915636.svg";